import { clsx } from 'clsx';

import ProductPlaceholder from '~/src/common/components/GridCard/CardPlaceholder/CardPlaceholder';
import CardDispatcher from '~/src/common/components/ProductsGrid/CardDispatcher';
import { SwiperConstrained } from '~/src/common/components/Swiper';
import I18n from '~/src/common/services/I18n';
import { sendCardEventClick } from '~/src/common/utils/product';
import { useGetCategory } from '~/src/queries/api-ecom/generated/api-ecom';

import styles from './RecipeXSellCategory.module.scss';

interface Props {
  className?: string;
}

/**
 * Test temporaire pour la cross sell de recettes sur la page de recette
 * Lorsque ce test sera termine une autre version plus perenne devra etre implemantee si celui ci se poursuit
 */
export const CATEGORY_ID_TEMPORARY_TEST = '6VtYsdbprSv6WbvA';

export const RecipeXSellCategory = (props: Props) => {
  const query = useGetCategory(CATEGORY_ID_TEMPORARY_TEST);

  const recipes = query.data?.items ?? [];

  if (query.isLoading && query.data == null)
    return (
      <div className={clsx(styles.container, props.className)}>
        <h4 className={styles.title}>{I18n.t('recipe-screen.category-xsell')}</h4>
        <SwiperConstrained key="placeholder">
          {Array.from({ length: 6 }, (_, idx) => (
            <ProductPlaceholder key={idx} />
          ))}
        </SwiperConstrained>
      </div>
    );

  if (query.data == null || recipes.length === 0) return null;

  return (
    <div className={clsx(styles.container, props.className)}>
      <h4 className={styles.title}>{I18n.t('recipe-screen.category-xsell')}</h4>
      <SwiperConstrained key="xsell-recipe">
        {recipes.map(recipe => (
          <CardDispatcher
            key={recipe.id}
            item={recipe}
            source={{
              type: 'recipe page cross sell',
              detail: { recipeId: recipe.id },
            }}
            eventSource="recipe page cross sell"
            onRefresh={query.refetch}
            onClick={product => sendCardEventClick(recipes, product, {})}
            analyticsProperties={{
              'number of products in the list': recipes.length,
              'number of cards in the list': recipes.length,
            }}
          />
        ))}
      </SwiperConstrained>
    </div>
  );
};
